module.exports = __webpack_public_path__ + "static/doctor-consulting-bee49a90b1589132d149c47acca094d9.png";